module.exports = __webpack_public_path__ + "img/wallet-minus.8d906f16.svg";